import { useSnackbar } from "notistack"
import React from "react"
import Package from "../../../../package.json"

import Paper from "@material-ui/core/Paper"
import { makeStyles } from "@material-ui/core/styles"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TableRow from "@material-ui/core/TableRow"
import Typography from "@material-ui/core/Typography"
import semPedidos_IMG from "../../../assets/ilustration/Money Save Illustration.svg"
import RowPagamentos from "./RowPagamentos"

import VisualizarPedido from "./visualizarPedido"

import { Print } from "@material-ui/icons"
import { Button } from "react-bootstrap"
import { RegistrarLogErro } from "../../../services/clientefiel"
import { imprimirFechamentoCaixa } from "../../../services/historicoCaixa"
import { gerarTextoFechamento } from "../../../services/textoFechamento"
import { buscarInformacoesMesa, buscarInformacoesPedido } from "../../../services/integracao"
import useAppStore from "../../../stores/AppStore"
import useLoadingStore from "../../../stores/LoadingStore"

const useStyles = makeStyles(theme => ({
    img: {},
    texto: {
        textAlign: "center",
        position: "relative",
        top: "-1rem",
    },
}))

export default function TablePagamentos(props) {
    const autorizacao = localStorage.getItem("chaveSistema")
    const { enqueueSnackbar } = useSnackbar()

    const { caixaSelecionada } = props

    const configuracoes = useAppStore(s => s.configuracoes)
    const mandarImprimir = useAppStore(s => s.mandarImprimir)

    const setLoading = useLoadingStore(s => s.setLoading)

    const [open, setOpen] = React.useState(-1)
    const [modalPedido, setModalPedido] = React.useState({})

    const classes = useStyles()

    const buscarPedido = async pedido => {
        try {
            setLoading(true)

            let respostaPedido

            if (pedido.idPedido) {
                respostaPedido = await buscarInformacoesPedido(
                    autorizacao,
                    pedido.idPedido,
                    configuracoes.user.parametros
                )
            } else if (pedido.idMesa) {
                respostaPedido = await buscarInformacoesMesa(
                    autorizacao,
                    pedido.idMesa,
                    configuracoes.user.parametros
                )

                if (!respostaPedido.retornoErro) {
                    respostaPedido = { ...respostaPedido, texto: gerarTextoMesa(respostaPedido) }
                }
            } else {
                enqueueSnackbar("Pedido ou mesa inválido")
                return
            }

            if (respostaPedido.retornoErro) {
                enqueueSnackbar(respostaPedido.mensagem)
            } else {
                setModalPedido(respostaPedido)
            }
        } catch (error) {
            enqueueSnackbar(
                `${Package.version} buscarPedido - ${window.location.hostname} - ${error}`
            )

            RegistrarLogErro(error, "buscarPedido", pedido?.idPedido || pedido?.idMesa)
        } finally {
            setLoading(false)
        }
    }

    const formatBRL = (v = 0) =>
        new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(
            Number(v) || 0
        )
    const line = (n = 48, ch = "-") => ch.repeat(n)
    const pad = (s = "", w, side = "end") =>
        (s + "").slice(0, w)[side === "end" ? "padEnd" : "padStart"](w, " ")

    const linhaComValor = (label, valor, largura) => {
        const vStr = formatBRL(valor || 0)
        const larguraLabel = largura - vStr.length - 1
        return pad(label, larguraLabel) + " " + vStr + "\n"
    }

    const quebraComPrefixo = (prefix, texto, largura) => {
        const palavras = (texto || "").split(/\s+/)
        const linhas = []
        let prefixSpaces = " ".repeat(prefix.length)
        let linha = prefix

        for (const palavra of palavras) {
            if (!palavra) continue
            const adicionar = linha === prefix || linha === prefixSpaces ? palavra : " " + palavra

            if (linha.length + adicionar.length > largura) {
                linhas.push(linha)
                linha = prefixSpaces + palavra
            } else {
                linha += adicionar
            }
        }

        if (linha.trim().length) linhas.push(linha)
        return linhas
    }

    const gerarTextoMesa = mesa => {
        const sep = "_______________________________________\n"

        const formatarCNPJ = (cnpj = "") =>
            cnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")

        const formatarTimestamp = ts => {
            if (!ts) return ""
            const d = new Date(ts)
            const dd = String(d.getDate()).padStart(2, "0")
            const mm = String(d.getMonth() + 1).padStart(2, "0")
            const yyyy = d.getFullYear()
            const hh = String(d.getHours()).padStart(2, "0")
            const mi = String(d.getMinutes()).padStart(2, "0")
            return `${dd}/${mm}/${yyyy} ${hh}:${mi}`
        }

        const pedidos = Array.isArray(mesa.pedidos) ? mesa.pedidos : []
        const pagamentos = Array.isArray(mesa.pagamentos) ? mesa.pagamentos : []
        const estab = mesa.estabelecimento

        let texto = sep + "\n\n\n\n"
        texto += `Mesa: ${mesa.numeroMesa}\n`
        texto += `Data: ${formatarTimestamp(mesa.dataAbertura)}\n`
        texto += sep + "\n"

        pedidos.forEach((pedido, idx) => {
            if (pedidos.length > 1) {
                texto += `--- Pedido #${pedido.id} ---\n`
                texto += `Cliente: ${pedido.nomePedido || pedido.cliente?.nome || "Anônimo"}\n\n`
            }

            const itens = Array.isArray(pedido.itens) ? pedido.itens : []
            itens.forEach(item => {
                texto += `${item.quantidade} X ${item.nome}\n`
                const opcoes = Array.isArray(item.itensOpcaoProduto) ? item.itensOpcaoProduto : []
                opcoes.forEach(op => {
                    texto += ` > ${op.quantidade || 1} X ${op.nome || op.descricao || ""}\n`
                })
                if (item.observacao) texto += ` Obs: ${item.observacao}\n`
                texto += `Valor: \t\t${formatBRL(
                    (item.valorUnitario || 0) * (item.quantidade || 1)
                )}\n`
            })

            if (idx < pedidos.length - 1) texto += "\n"
        })

        texto += sep + "\n"

        pagamentos.forEach(pg => {
            texto += `Pagamento: \t${pg.formaPagamento?.descricao || "N/D"}\n`
        })

        const subTotal = pedidos.reduce((acc, p) => acc + (p.subTotal || 0), 0)
        const desconto = mesa.valorDesconto || 0
        const taxaAdicional = mesa.valorAdicional || 0
        const total = pedidos.reduce((acc, p) => acc + (p.valorTotal || 0), 0)

        texto += `Subtotal: \t\t${formatBRL(subTotal)}\n`
        texto += `Desconto: \t\t${formatBRL(desconto)}\n`
        texto += `Taxa Adicional: \t\t${formatBRL(taxaAdicional)}\n`
        texto += `TOTAL: \t\t\t${formatBRL(total)}\n`

        texto += sep

        if (estab) {
            if (estab.cnpj) texto += `CNPJ: ${formatarCNPJ(estab.cnpj)}\n`
            texto += `${estab.nome || ""}\n`
        }

        return texto
    }

    const gerarTextoNotinha = caixa => {
        const colunasPorLinhaImpressao = configuracoes.user.parametros.colunasPorLinhaImpressao

        const pagamentos = Array.isArray(caixa?.pagamentos) ? caixa.pagamentos : []

        let texto = `${line(colunasPorLinhaImpressao, "=")}\n\n`
        texto += "Fechamento de Caixa\n\n"
        texto += `${line(colunasPorLinhaImpressao, "=")}\n`

        texto += linhaComValor(
            "Dinheiro inicial:",
            caixa?.dinheiroInicial ?? 0,
            colunasPorLinhaImpressao
        )
        texto += linhaComValor("Vendas:", caixa?.somaVenda || 0, colunasPorLinhaImpressao)
        texto += linhaComValor("Retirada:", caixa?.totalSangriaCaixa || 0, colunasPorLinhaImpressao)
        texto += linhaComValor(
            "Adicionado:",
            caixa?.totalInjecaoCaixa || 0,
            colunasPorLinhaImpressao
        )
        texto += linhaComValor(
            "Valor em Caixa:",
            caixa?.somaDinheiroEmCaixa || 0,
            colunasPorLinhaImpressao
        )

        texto += line(colunasPorLinhaImpressao) + "\n"

        pagamentos.forEach(pagamento => {
            const descricao = pagamento?.descricao || "N/D"
            const qtd = Number(pagamento?.quantidade ?? 0)
            const total = Number(pagamento?.total ?? 0)

            texto += `${qtd}x ${String(descricao).toUpperCase()}\n`
            texto += linhaComValor("Total", total, colunasPorLinhaImpressao)
        })

        if (caixa?.retiradasDoCaixa?.length) {
            texto += line(colunasPorLinhaImpressao) + "\n"
            texto += `Alterações\n`
            caixa.retiradasDoCaixa.forEach(rdc => {
                const label = rdc.tipo === 1 ? "Adicionado" : "Retirada"
                texto += linhaComValor(label, rdc.valor || 0, colunasPorLinhaImpressao)

                if (rdc.motivo) {
                    const linhasMotivo = quebraComPrefixo(
                        "Motivo: ",
                        rdc.motivo,
                        colunasPorLinhaImpressao
                    )
                    texto += linhasMotivo.join("\n") + "\n"
                }
            })
        }

        return texto
    }

    const imprimir = () => {
        const texto = gerarTextoNotinha(caixaSelecionada)
        mandarImprimir({ texto: texto, numeroDaImpressora: 1 })
    }

    // Imprime o FECHAMENTO do caixa selecionado, montado a partir da estrutura
    // retornada pelo servidor (endpoint caixa/ImprimirFechamentoCaixa).
    const imprimirServidor = async () => {
        try {
            setLoading(true)

            if (!caixaSelecionada?.id) {
                enqueueSnackbar("Caixa sem identificador para impressão.", { variant: "error" })
                return
            }

            const resp = await imprimirFechamentoCaixa(autorizacao, caixaSelecionada.id)
            if (resp?.retornoErro || !resp?.cabecalho) {
                enqueueSnackbar(
                    resp?.mensagem || "Não foi possível obter o fechamento do servidor.",
                    { variant: "error" }
                )
                return
            }

            const largura = configuracoes?.user?.parametros?.colunasPorLinhaImpressao
            const texto = "\n\n" + gerarTextoFechamento(resp, largura)
            mandarImprimir({ texto: texto, numeroDaImpressora: 1, isResumo: true })
        } catch (error) {
            RegistrarLogErro(error, "imprimirServidor", "")
            enqueueSnackbar("Erro ao imprimir o fechamento do servidor.", { variant: "error" })
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            {caixaSelecionada.pagamentos.length > 0 && (
                <Button
                    style={{
                        backgroundColor: "blue",
                        color: "white",
                        marginBottom: "0.5em",
                    }}
                    onClick={() => {
                        imprimir()
                    }}
                    size="small"
                    className={classes.button}
                >
                    <Typography>
                        <Print /> Imprimir (antigo)
                    </Typography>
                </Button>
            )}
            {caixaSelecionada.abertoEm && (
                <Button
                    style={{
                        backgroundColor: "#0a7d2c",
                        color: "white",
                        marginBottom: "0.5em",
                        marginLeft: "0.5em",
                    }}
                    onClick={() => {
                        imprimirServidor()
                    }}
                    size="small"
                    className={classes.button}
                >
                    <Typography>
                        <Print /> Imprimir Fechamento
                    </Typography>
                </Button>
            )}
            <TableContainer component={Paper}>
                {caixaSelecionada.pagamentos.length > 0 ? (
                    <Table aria-label="collapsible table">
                        <VisualizarPedido pedido={modalPedido} setModalPedido={setModalPedido} />
                        <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell>Forma Pagamento</TableCell>
                                <TableCell align="right">Total</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {caixaSelecionada.pagamentos?.map((pagamento, index) => (
                                <RowPagamentos
                                    buscarPedido={buscarPedido}
                                    key={index}
                                    index={index}
                                    open={open}
                                    setOpen={setOpen}
                                    pagamento={pagamento}
                                    pedidos={caixaSelecionada.pedidosDoCaixa.filter(
                                        pedido => pagamento.descricao === pedido.formaPagamento
                                    )}
                                />
                            ))}
                        </TableBody>
                    </Table>
                ) : (
                    <div>
                        <img
                            src={semPedidos_IMG}
                            className={classes.img}
                            alt="sem pedidos associados a esse caixa"
                        />
                        <Typography className={classes.texto}>
                            Você ainda não recebeu pedidos associados a esse caixa.
                        </Typography>
                    </div>
                )}
            </TableContainer>
        </>
    )
}
